import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { BuildingsService } from '../../../service/buildings.service';
import { environment } from '../../../../environments/environment';
declare var $ : any;
declare var loadImage:any;
//declare var require:any;

@Component({
  selector: 'app-cover-photo',
  templateUrl: './cover-photo.component.html',
  styleUrls: ['./cover-photo.component.css']
})
export class CoverPhotoComponent implements OnInit, AfterViewInit {

  @Input() coopBuilding:any;
  file;
  fileList;
  s3ApiUrl = environment.s3BucketApi;
  isLoading = false;
  defaultShade = false;
  currentImage;
  indexNo;
  toggleNumb : number = 1;

  source = '../../../../assets/images/cover-photo/Hover-Black-tint1.png';
  editableImage;

 isImageDivToggle = false;
 tmppath;
 isShowSaveButton;

  constructor(private buildingService: BuildingsService) { }

  ngOnInit() {

    // var that = this;
    // $('.carousel').on('slide.bs.carousel', function (ev) {
    //   console.log('ddddd--d-d-d-d-d-d-d-d-d-dd-')
    //  var imgSrc = $(ev.relatedTarget).find('img').attr('src');
    //  if(imgSrc){
    //   imgSrc = imgSrc.split('/')
    //   that.currentImage = imgSrc[imgSrc.length-1]
    //  }  
     
    // });

  }

  cancelCoverImageToS3(){
    $('.image-editor').cropit('disable')
    this.isLoading = false;
    this.isImageDivToggle = false;
    this.isShowSaveButton = false;
  }

  uploadFunction(uploadButton){
      $(uploadButton).trigger('click');
  }

  ngAfterViewInit(){

    // $('.carousel').carousel({
    //   interval: 5000
    // });

    // var that = this;
    // $('.carousel').on('slide.bs.carousel', function (ev) {
    //  var imgSrc = $(ev.relatedTarget).find('img').attr('src');
    //  if(imgSrc){
    //   imgSrc = imgSrc.split('/')
    //   that.currentImage = imgSrc[imgSrc.length-1]
    //  }    
    // });
  }
    

    fileChange(files){
      
          this.fileList =  files.target.files;
          if(this.fileList.length > 0) {
            this.file = this.fileList[0];
      
              var Extension = this.file.name.substring(
              this.file.name.lastIndexOf('.') + 1).toLowerCase();
      
              if (Extension == "gif" || Extension == "png" || Extension == "bmp"
                    || Extension == "jpeg" || Extension == "jpg") {
                      if(this.file.size > 1024 * 1024 * 20){
                        alert('Maximum file size should be 20mb')
                        this.file = null;
                      }else{

                        this.tmppath = URL.createObjectURL(files.target.files[0]);
                        this.isImageDivToggle = true;
                        this.fixOrientation(this.file);
                      }
      
              }else{
                alert('Allowed files- gif, png, jpeg, jpg, bmp');
                this.file = null;
              }
      
          }
        }

        fixOrientation(file){

          

          var that = this;
          loadImage.parseMetaData(file, function(data) {
            //default image orientation
            var orientation = 0;
            //if exif data available, update orientation
            if (data.exif) {
                orientation = data.exif.get('Orientation');
            }
            var loadingImage = loadImage(
                file,
                function(canvas) {
                    //here's the base64 data result
                    var base64data = canvas.toDataURL('image/jpeg');
                    //here's example to show it as on imae preview
                    that.editableImage = base64data;
                    that.isLoading = true;
                   
                    var img_src = base64data; //.replace(/^data\:image\/\w+\;base64\,/, 'base64');
                    //console.log(img_src)
                    $('#result-preview').attr('src', base64data);


                   setTimeout(() => {
                    //that.isImageDivToggle = true;
                    
                    $('.image-editor').cropit({

                      onImageLoading : function loading(e) {
                        
                      },

                      onImageLoaded :function loaded(e) {
                        that.isLoading = false;
                        that.isShowSaveButton = true;
                      },

                      imageState: {
                        src: that.editableImage,
                      },

                      onImageError: function(e) {
                       that.isLoading = false;
                       console.log(e)
                       if (e.code === 1) {
                        that.isImageDivToggle = false;
                        alert(e.message)
                       }
                      }
                    });
                    $('.rotate-cw').click(function() {
                      $('.image-editor').cropit('rotateCW');
                    });
                    $('.rotate-ccw').click(function() {
                      $('.image-editor').cropit('rotateCCW');
                    });
                    
                   }, 2000);                 
                }, {
                    //should be set to canvas : true to activate auto fix orientation
                    canvas: true,
                    orientation: orientation
                }
            );
        });
         
        }

        getPosData(){
          $('#saveImg').click(function(){
            var picture = $('#sample_picture');
            var data = picture.guillotine('getData');
            
        })
        }

        uploadToS3(){

          let imageData = $('.image-editor').cropit('export');
          let fileObj = {
            image : imageData,
            id: this.coopBuilding.id
          }
         
          this.isLoading = true;
          this.isImageDivToggle = false;
          this.isShowSaveButton = false;
          this.buildingService.uploadBuildingCoverPhoto(fileObj).subscribe((res)=>{
           console.log(res)
           
            this.isLoading = false;
            if(res.success){
              if(res.building && res.building.coverPhoto){
                this.coopBuilding.coverPhoto = res.building.coverPhoto;
                this.currentImage = res.building.coverPhoto[res.building.coverPhoto.length - 1]
                $('.carousel').carousel('pause'); 
                setTimeout(() => {
                  $('.carousel-inner').find('.item').removeClass('active');
                  $('.carousel-inner').find('.item').last().addClass('active');

                  // var that = this;
                  // $('.carousel').on('slide.bs.carousel', function (ev) {
                  //  var imgSrc = $(ev.relatedTarget).find('img').attr('src');
                  //  if(imgSrc){
                  //   imgSrc = imgSrc.split('/')
                  //   that.currentImage = imgSrc[imgSrc.length-1]
                  //  }    
                  // });
                    
                }, 500);
                setTimeout(() => {
                  $('.carousel').carousel('cycle'); 
                }, 5000);
              }
            }
          });
          
        }

        mouseEnter(){
        if(($(window).innerWidth() > 767)){
          if(this.coopBuilding && this.coopBuilding.coverPhoto && this.coopBuilding.coverPhoto.length > 0){          
            if(this.coopBuilding && !this.coopBuilding.coverPhoto){
            this.defaultShade = true;
            this.source = '../../../../assets/images/cover-photo/Hover-Black-tint.png';
          }else{
            this.source = '../../../../assets/images/cover-photo/hoverblacktint.png';          
          }
        }
      }
        }

        mouseLeave(){
          if(this.coopBuilding && this.coopBuilding.coverPhoto && this.coopBuilding.coverPhoto.length > 0){                      
          this.defaultShade = false;
          this.source = '../../../../assets/images/cover-photo/Hover-Black-tint1.png';
        }
        this.toggleNumb = 1;
        $('.bannerCarousel .hoverEffect').removeClass('active');
      }
      mobileControls(){
        if(($(window).innerWidth() < 767)){
          if(this.toggleNumb === 1){
            if(this.coopBuilding && this.coopBuilding.coverPhoto && this.coopBuilding.coverPhoto.length > 0){          
              if(this.coopBuilding && !this.coopBuilding.coverPhoto){
              this.defaultShade = true;
              this.source = '../../../../assets/images/cover-photo/Hover-Black-tint.png';
            }else{
              this.source = '../../../../assets/images/cover-photo/hoverblacktint.png';          
            }
          }
          $('.bannerCarousel .hoverEffect').addClass('active');
            this.toggleNumb = 0;
          }
          else{
            if(this.coopBuilding && this.coopBuilding.coverPhoto && this.coopBuilding.coverPhoto.length > 0){                      
              this.defaultShade = false;
              this.source = '../../../../assets/images/cover-photo/Hover-Black-tint1.png';
            }
              $('.bannerCarousel .hoverEffect').removeClass('active');
              this.toggleNumb = 1;
          }
        }
      }

      bannerControl(){

        if(this.coopBuilding && this.coopBuilding.coverPhoto && this.coopBuilding.coverPhoto.length > 0){          
          if(this.coopBuilding && !this.coopBuilding.coverPhoto){
          this.defaultShade = true;
          this.source = '../../../../assets/images/cover-photo/Hover-Black-tint.png';
        }else{
          this.source = '../../../../assets/images/cover-photo/hoverblacktint.png';          
        }
      }
      this.toggleNumb = 0;
      $('.bannerCarousel .hoverEffect').addClass('active');
      }
      removeCoverPhoto(){
        $('.carousel').carousel('pause'); 
        this.isLoading = true;       
        setTimeout(() => {
          let ele = $('.carousel-inner').find('.item.active').find('img').attr('src')
          ele = ele.split('/');
          let imageToRemove = ele[ele.length - 1];
          imageToRemove = 'cover/'+imageToRemove;
          let cover = {
            id: this.coopBuilding.id,
            image: imageToRemove
          }
  
          this.buildingService.removeCoverPhoto(cover).subscribe((res)=>{
            console.log(res)
            if(res.success){
              if(res.building && res.building.coverPhoto){
                this.indexNo = this.coopBuilding.coverPhoto.indexOf(this.currentImage);
                this.coopBuilding.coverPhoto = res.building.coverPhoto;
                this.currentImage = res.building.coverPhoto[0]
                setTimeout(() => {
                  this.isLoading = false;
                }, 1000);
                $('.carousel-inner').find('.item').removeClass('active');
                $('.carousel-inner').find('.item:first-child').addClass('active');            
                
                setTimeout(() => {
                  $('.carousel').carousel('cycle');                 
                }, 2000);
              }
            }
          });
        }, 2000);
       
      }
}
